export const SEGMENT = {
  ENTERPRISE: 'ENTERPRISE'
};

export const DATE_FORMATS = {
  YYYY_MM_DD: 'YYYY-MM-DD',
  DD_MMM_YYYY: 'DD MMM YYYY'
};
export const START_END_DATE_DIFF = 4;

export const TABLE_HEADERS = [
  {
    headerName: 'LSI ID',
    key: 'lsiId'
  },
  {
    headerName: 'Site Installation Address',
    key: 'installationAddress'
  },
  {
    headerName: 'Airtel Project Manager Details',
    key: 'pmDetails'
  },
  {
    headerName: 'Site Contact Details',
    key: 'contactDetails'
  },
  {
    headerName: 'Customer Need by Date',
    key: 'customerNeedByDate'
  },
  {
    headerName: 'Site Readiness ',
    key: 'siteReadiness'
  },
  {
    headerName: 'Appointment Date & Time',
    key: 'appointmentDate'
  },
  {
    headerName: 'Actions',
    key: 'actions'
  }
];

export const MOCK_RESPONSE_GET_DETAILS = {
  role: 'Lcon',
  cpmFirstName: 'Pranav',
  cpmLastName: 'Kapur',
  cpmEmail: 'pkapur@airtel.com',
  cpmPhoneNumber: '9999999999',
  accountName: 'ABC',
  pmFirstName: 'Virat',
  pmLastName: 'Kohli',
  pmPhoneNumber: '9999999999',
  pmEmail: 'test@airtel.com',
  customerSegment: 'SMB',
  product: 'Dedicated Internet',
  orderType: 'NEW',
  orderSubType: 'NEW',
  sites: [
    {
      lsiId: 'lsi_1234',
      dcpFirstName: 'Virat',
      dcpLastName: 'Kohli',
      dcpEmail: 'test@airtel.com',
      dcpPhoneNumber: '9999999999',
      installationAddress: 'Sector 18, Airtel',
      circle: 'NCR',
      pincode: '122001',
      siteReadinessStatus: true,
      siteReadinessDate: '2023-12-23',
      customerNeedByDate: '2023-12-23',
      media: '',
      orderType: 'New',
      appointmentId: 'txn12345678',
      appointmentDate: '2023-12-23',
      appointmentStartTime: '08:00:00',
      appointmentEndTime: '10:00:00',
      subOrderGenerated: false
    },
    {
      lsiId: 'lsi_1235',
      dcpFirstName: 'Virender',
      dcpLastName: 'Sehwag',
      dcpEmail: 'test@airtel.com',
      dcpPhoneNumber: '9999999999',
      installationAddress: 'Sector 23, Xyz Enterprises',
      circle: 'NCR',
      pincode: '122001',
      siteReadinessStatus: true,
      siteReadinessDate: '2023-12-23',
      customerNeedByDate: '2023-12-23',
      media: '',
      orderType: 'New',
      appointmentId: 'txn12345678',
      appointmentDate: '2023-12-28',
      appointmentStartTime: '10:00:00',
      appointmentEndTime: '12:00:00',
      subOrderGenerated: false
    }
  ]
};

export const PRODUCT_TYPE = {
  DEDICATED_INTERNET: 'Internet',
  VPN: 'VPN',
  NLD: 'NLD',
  LL: 'LL'
};

export const getProductDisplayName = (product) => {
  const displayMap = {
    [PRODUCT_TYPE.DEDICATED_INTERNET]: 'Dedicated Internet',
    [PRODUCT_TYPE.VPN]: 'VPN',
    [PRODUCT_TYPE.NLD]: 'NLD (Direct VPN)',
    [PRODUCT_TYPE.LL]: 'LL'
  };
  return displayMap[product] ? displayMap[product] : '-';
};
